import { CircleHelp } from 'lucide-react';

import { Tooltip } from '@/components/ui/tooltip';

export function TooltipAdditionalRecipients() {
  return (
    <Tooltip content="These recipients will be e-mailed on your behalf">
      <CircleHelp className="size-4 text-gray-400" />
    </Tooltip>
  );
}
